(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('report-execute', {
            parent: 'entity',
            url: '/report-execute',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ReportExecutes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report-execute/report-executes.html',
                    controller: 'ReportExecuteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('report-execute-detail', {
            parent: 'entity',
            url: '/report-execute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ReportExecute'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report-execute/report-execute-detail.html',
                    controller: 'ReportExecuteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReportExecute', function($stateParams, ReportExecute) {
                    return ReportExecute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'report-execute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('report-execute-detail.edit', {
            parent: 'report-execute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-dialog.html',
                    controller: 'ReportExecuteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReportExecute', function(ReportExecute) {
                            return ReportExecute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('report-execute.new', {
            parent: 'report-execute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-dialog.html',
                    controller: 'ReportExecuteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reportField: null,
                                reportCondition: null,
                                reportValue: null,
                                reportValue2: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('report-execute', null, { reload: 'report-execute' });
                }, function() {
                    $state.go('report-execute');
                });
            }]
        })
        .state('report-execute.edit', {
            parent: 'report-execute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-dialog.html',
                    controller: 'ReportExecuteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReportExecute', function(ReportExecute) {
                            return ReportExecute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('report-execute', null, { reload: 'report-execute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('report-execute.delete', {
            parent: 'report-execute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-delete-dialog.html',
                    controller: 'ReportExecuteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReportExecute', function(ReportExecute) {
                            return ReportExecute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('report-execute', null, { reload: 'report-execute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
